module.exports = __webpack_public_path__ + "static/media/about-us.56c14ace.png";